<template>
	<div id="dashboard-acc-info">
		<div class="dash__section-title">Account Information</div>

		<div class="box" v-if="userDetails">
			<ul class="box__user-info">
				<li class="email">{{userDetails.email}}</li>
				<li class="primary-phone">{{userDetails.phoneNumber}}</li>
				<li class="secondary-phone" v-if="userDetails.phoneNumberTwo">{{userDetails.phoneNumberTwo}}</li>
				<div class="address">
					<li v-if="userDetails.addressLineOne">{{userDetails.addressLineOne}}</li>
					<li v-if="userDetails.addressLineTwo">{{userDetails.addressLineTwo}}</li>
					<li v-if="userDetails.city">{{userDetails.city}}</li>
					<li v-if="userDetails.postCode">{{userDetails.postCode}}</li>
					<div class="clearfix"></div>
				</div>
			</ul>
		</div>

	</div>
</template>

<script>
	export default {
		computed : {
			userDetails(){
				return this.$store.getters.getUserInfo
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/common/Dashboard/DBAccountInfo.vue